import type { FC } from 'react';
import React from 'react';
import { useTheme } from 'next-themes';

import { DARK_THEME_KEY, LIGHT_THEME_KEY } from '@constants/theme';
import { useTranslationResponse } from '@isomorphic/hooks/use-translation-response';
import { StyledThemeSwitcherWrapper, StyledThemeDivider, StyledThemeSwitcher } from './ThemeSwitcher.styles';

export const ThemeSwitcher: FC = () => {
  const { resolvedTheme, setTheme } = useTheme();
  const light = useTranslationResponse('Light');
  const dark = useTranslationResponse('Dark');
  const ariaLabelThemeSwitcher = useTranslationResponse('AriaLabelThemeSwitcher');
  const ariaLabelLight = useTranslationResponse('AriaLabelLight');
  const ariaLabelDark = useTranslationResponse('AriaLabelDark');

  // Handle undefined resolvedTheme during hydration - default to light
  const currentTheme = resolvedTheme || LIGHT_THEME_KEY;

  const toggleTheme = () => {
    setTheme(currentTheme === LIGHT_THEME_KEY ? DARK_THEME_KEY : LIGHT_THEME_KEY);
  };

  return (
    <StyledThemeSwitcherWrapper>
      <StyledThemeDivider />
      <StyledThemeSwitcher
        onClick={toggleTheme}
        className={`theme-switcher ${currentTheme}`}
        aria-label={ariaLabelThemeSwitcher}
      >
        <button
          type="button"
          className="theme-switcher__light"
          aria-label={ariaLabelLight}
          aria-pressed={currentTheme === LIGHT_THEME_KEY ? 'true' : 'false'}
          tabIndex={0}
        >
          <span className="theme-switcher__icon theme-switcher__icon--light" aria-hidden="true" />
          <span className="theme-switcher__text">{light}</span>
        </button>
        <button
          type="button"
          className="theme-switcher__dark"
          aria-label={ariaLabelDark}
          aria-pressed={currentTheme === DARK_THEME_KEY ? 'true' : 'false'}
          tabIndex={0}
        >
          <span className="theme-switcher__icon theme-switcher__icon--dark" aria-hidden="true" />
          <span className="theme-switcher__text">{dark}</span>
        </button>
      </StyledThemeSwitcher>
    </StyledThemeSwitcherWrapper>
  );
};
